import {userService} from '@/common/api.service'
import Axios from 'axios'
import { userTypes } from '@/constants/userTypes'

const initialStates = {
    status: 'loading',
    findCatStatus: 'loading',
    findGroupStatus: 'loading',
    findGroupsStatus: 'loading',
    catMembersStatus: 'loading',
    current_user: {},
    user: {},
    usersList: [],
    refererList: [
        {
        full_name: '',
        hashid: 0,
        phone: null
        }
    ],
    transactionStatistics: {},
    activitiesLogs : {},
    namad_error: {},
    usersListStatus: 'loading',
    new_user: {},
    categorizedUsers: {},
    categoryData: {},
    groupData: {},
    groupsData: {},
    starShopActivitiesLogs: {},
    excelRequests: {data: []},
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    success(state, current_user) {
        state.status       = 'success'
        state.current_user = current_user
    },
    fail(state) {
        state.status       = 'fail'
        state.current_user = {}
    },
    setAuthenticatePending(state) {
        state.current_user.is_authenticated_pending = true;
        state.current_user.is_authenticated         = false;
    },
    userFindSuccess(state, user) {
        state.status = 'success'
        state.user = user
    },
    userShebaNumbers(state, sheba_numbers) {
        state.status = 'success'
        state.user.sheba_numbers = sheba_numbers
    },
    usersList(state, users) {
        state.status = 'success'
        state.usersListStatus = 'success'
        state.usersList = users
    },
    refererList(state, referers) {
        state.status = 'success'
        state.refererList = referers
    },
    transactionStatistics(state, transactionStatistics) {
        state.status = 'success'
        state.transactionStatistics = transactionStatistics
    },
    activitiesLogs(state, activityLogs) {
        state.status = 'success'
        state.activitiesLogs = activityLogs
    },
    starShopActivitiesLogs(state, activityLogs) {
        state.status = 'success'
        state.starShopActivitiesLogs = activityLogs
    },
    categorizedUsers(state, users) {
        state.catMembersStatus = 'success'
        state.categorizedUsers = users
    },
    categoryData(state, data) {
        state.categoryData = data
        state.findCatStatus = 'success'
    },

    groupData(state, data) {
        state.groupData = data
        state.findGroupStatus = 'success'
    },

    categoryGroups(state, data) {
        state.groupsData = data
        state.findGroupsStatus = 'success'
    },

    setExcelRequests(state , response) {
        state.excelRequests = response.data
        state.status    = 'success'
    }

}

const getters = {
    excelRequests: state => state.excelRequests,
    current_user: ({current_user}) => current_user,
    status: ({status}) => status,
    usersListStatus: ({usersListStatus}) => usersListStatus,
    is_authenticated: ({current_user}) => current_user.is_authenticated || false,
    is_authenticated_pending: ({current_user}) => current_user.is_authenticated_pending || false,
    profile_completed: ({current_user}) => {
        if (current_user.user_type == userTypes.LEGAL) {
            return current_user.username
                && current_user.email
                && current_user.phone
                && current_user.telephone
                && current_user.com_name_fa
                && current_user.com_name_en
                && current_user.national_legal_code
                && current_user.register_number
                && current_user.register_date
                && current_user.signature_holder
                && current_user.signature_holder.first_name_fa
                && current_user.signature_holder.last_name_fa
                && current_user.signature_holder.father_name_fa
                && current_user.signature_holder.first_name_en
                && current_user.signature_holder.last_name_en
                && current_user.signature_holder.father_name_en
                && current_user.signature_holder.national_code
                && current_user.signature_holder.birth_date
                && current_user.technical_agent
                && current_user.technical_agent.first_name
                && current_user.technical_agent.last_name
                && current_user.technical_agent.phone_number
                && current_user.technical_agent.telephone_number
                && current_user.technical_agent.email;
        }

        return current_user.username
            && current_user.first_name
            && current_user.first_name_en
            && current_user.father_name
            && current_user.father_name_en
            && current_user.last_name
            && current_user.last_name_en
            && current_user.birth_date
            && current_user.telephone
            && current_user.national_code
            && current_user.email ? true : false
    },
    is_current_user_fetched: ({current_user}) => current_user.username !== undefined,
    user: ({user}) => user,
    sheba_numbers: ({user}) => user.sheba_numbers,
    usersSelectable: ({usersList}) => usersList,
    referersList: state => state.refererList,
    transactionStatistics: state => state.transactionStatistics,
    activitiesLogs: state =>state.activitiesLogs,
    starShopActivitiesLogs: state => state.starShopActivitiesLogs,
    new_user: state => state.new_user,
    categorizedUsers: state => state.categorizedUsers,
    categoryData: state => state.categoryData,
    groupData: state => state.groupData,
    findCatStatus: state => state.findCatStatus,
    findGroupStatus: state => state.findGroupStatus,
    catMembersStatus: state => state.catMembersStatus,
    groupsData: state => state.groupsData,
    findGroupsStatus: state => state.findGroupsStatus,
}

const actions = {
    fetchCurrent({commit}) {
        commit('loading')
        return userService.current().then(response => {
            commit('success', response.data.data)
        }).catch(error => {
            localStorage.removeItem('access_token')
            delete Axios.defaults.headers.common['Authorization']
        })
    },
    fetchByHashId({commit}, hashid) {
        commit('loading')
        return userService.find(hashid).then(
            response => {
                commit('userFindSuccess', response.data.data)
            }
        )
    },
    fetchShebaNumbers({commit, state}) {
        commit('loading')
        return userService.fetchShebaNumbers(state.user.id).then(
            response => {
                commit('userShebaNumbers', response.data.data)
            }
        )
    },
    fetchForSelect({commit}) {
        commit('loading')
        return userService.fetchForSelect().then(
            response => {
                commit('usersList', response.data.data)
            }
        )
    },
    fetchCategorizedUsers({commit}) {
        commit('loading')
        return userService.fetchForSelect().then(
            response => {
                commit('usersList', response.data.data)
            }
        )
    },
    fetchReferers({commit}) {
        commit('loading')
        return userService.fetchReferers().then(
            response => {
                commit('refererList', response.data.data)
            }
        )
    },
    fetchTransactionStatistics({commit},hashid) {
        commit('loading')
        return userService.fetchTransactionStatistics(hashid).then(
            response => {
                commit('transactionStatistics', response.data.data)
            }
        )
    },
    fetchActivitiesLogs({commit}, params) {
        commit('loading')
        return userService.fetchActivitiesLogs(params).then(
            response => {
                commit('activitiesLogs', response.data.data)
            }
        )
    },
    fetchStarShopActivitiesLogs({commit}, params) {
        commit('loading')
        return userService.fetchStarShopActivitiesLogs(params).then(
            response => {
                commit('starShopActivitiesLogs', response.data.data)
            }
        )
    },
    fetchCategory({commit}, hashid) {
        commit ('loading')
        return userService.fetchCategory(hashid).then(
            response => {
                commit('categoryData', response.data.data)
            }
        )
    },

    fetchCategoryMembers({commit}, hashid) {
        return userService.fetchCategoryMembers(hashid).then(
            response => {
                commit('categorizedUsers', response.data.data.data)
            }
        )
    },

    fetchGroup({commit}, hashid) {
        commit ('loading')
        return userService.fetchGroup(hashid).then(
            response => {
                commit('groupData', response.data.data)
            }
        )
    },

    fetchCategoryGroups({commit}, hashid) {
        return userService.fetchCategoryGroups(hashid).then(
            response => {
                commit ('categoryGroups', response.data.data)
            }
        )
    },

    fetchCoreExcelRequests({commit} , query){
        commit('loading')
        return userService.fetchCoreExcelRequests(query)
            .then(response => {

                commit('setExcelRequests' , response.data)
            })
    }
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}
